<template>
  <div
    v-if="visible"
    :id="uid"
    class="toast"
    :class="classControl"
    :role="role"
    :aria-live="ariaLive"
    aria-atomic="true"
    data-bs-autohide="false"
  >
    <div class="d-flex flex-row">
      <div class="alert-icon">
        <ips-icon v-if="iconType" :icon="iconType" :class="iconClasses"></ips-icon>
      </div>
      <slot :close="dismissToast" name="content">
        <div class="w-100">
          <div v-if="title" class="toast-heading">
            <span>{{ title }}</span
            ><span>
              <button
                v-if="dismissible"
                type="button"
                class="btn-dismiss"
                data-bs-dismiss="toast"
                aria-label="Close"
                @click="dismissToast"
              >
                <ips-icon icon="ico-close" size="sm"></ips-icon>
              </button>
            </span>
          </div>
          <div class="toast-body">
            <div v-if="message">
              <span>{{ message }}</span>
              <ips-button
                v-if="buttonText"
                class="ms-5"
                size="sm"
                variant="secondary"
                @click="onClick"
              >
                {{ buttonText }}
              </ips-button>
            </div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import IpsButton from '@ipscape/ips-button';
import IpsIcon from '@ipscape/ips-icon';
import { alertMixin } from '../../../mixins/index.js';

export default {
  name: 'IpsToast',
  components: {
    IpsButton,
    IpsIcon,
  },
  mixins: [alertMixin],
  props: {
    id: {
      name: 'id',
      description: 'The id of the toast. Defaults to uid if not provided',
      type: String,
      default: null,
      required: false,
    },
    dismissible: {
      name: 'dismissible',
      description: 'Makes a toast dismissible if true',
      type: Boolean,
      default: false,
      required: false,
    },
    timeout: {
      name: 'timeout',
      description:
        'Time (in milliseconds) until toast is automatically hidden. Use 0 to keep open indefinitely.',
      type: Number,
      default: 0,
      required: false,
    },
    buttonText: {
      name: 'buttonText',
      description: 'Shows a button with this text when set',
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return { visible: true };
  },
  computed: {
    isDismissible() {
      return this.dismissible;
    },
    classControl() {
      const classesArray = ['ips'];
      if (this.visible) classesArray.push('show');
      if (this.iconType) classesArray.push('ips-toast--icon');
      if (this.variant === 'message') {
        classesArray.push('toast-secondary');
      } else {
        classesArray.push(`toast-${this.variant}`);
      }
      return classesArray;
    },
    uid() {
      return this.id ? this.id : this._uid;
    },
    ariaLive() {
      return this.variant === 'danger' ? 'assertive' : 'polite';
    },
  },
  created() {
    if (this.timeout > 0) {
      setInterval(() => {
        this.visible = false;
      }, this.timeout);
    }
  },
  methods: {
    dismissToast() {
      this.visible = false;
    },
    onClick(event) {
      this.$emit('toast-button-clicked', event);
      this.dismissToast();
    },
  },
};
</script>

<style lang="scss">
@import 'IpsToast';
</style>
